import React, { useRef } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const RecaptchaComponent = ({ onVerify, onError, siteKey }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const recaptchaRef = useRef(null);

  const handleExecuteRecaptcha = async () => {
    if (!executeRecaptcha) {
      console.warn('reCAPTCHA not loaded yet, retrying...');
      // Wait a bit and try again
      await new Promise(resolve => setTimeout(resolve, 1000));
      if (!executeRecaptcha) {
        onError?.('reCAPTCHA not loaded yet');
        return null;
      }
    }

    try {
      const token = await executeRecaptcha('submit');
      if (token) {
        onVerify?.(token);
        return token;
      } else {
        onError?.('reCAPTCHA verification failed - no token received');
        return null;
      }
    } catch (error) {
      console.error('reCAPTCHA execution failed:', error);
      onError?.('reCAPTCHA verification failed');
      return null;
    }
  };

  // Expose handleExecuteRecaptcha function to parent component
  React.useImperativeHandle(recaptchaRef, () => ({
    executeRecaptcha: handleExecuteRecaptcha
  }));

  return (
    <div>
      <div className="text-muted small">
        <i className="fas fa-shield-alt me-1"></i>
        This site is protected by reCAPTCHA and the Google 
        <a 
          href="https://policies.google.com/privacy" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-decoration-none ms-1"
        >
          Privacy Policy
        </a> and 
        <a 
          href="https://policies.google.com/terms" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-decoration-none ms-1"
        >
          Terms of Service
        </a> apply.
      </div>
    </div>
  );
};

export default RecaptchaComponent;
